module.exports = __webpack_public_path__ + "img/action-good.3bb245ab.svg";